import { useState, forwardRef, useImperativeHandle } from 'react';

import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';

import Dialog from '@base/Dialog';
import VisualizadorDeArquivo from '@base/VisualizadorDeArquivo';

export const VisualizarDEDialog = forwardRef((props, ref) => {

  const [open, setOpen] = useState(props.aberto ?? false);
  useImperativeHandle(ref, () => ({
    closeDialog() {
      setOpen(false);
    }
  }));

  return (
    <Dialog
      maxWidth={'md'}
      fullWidth={true}
      closeDialog={props.aoFechar}
      openDialog={open}
      title='DE'
    >
      <Grid container alignItems='center' spacing={3}>
        <Grid item>
          {props.blob ? <VisualizadorDeArquivo blob={props.blob} /> : <CircularProgress size={16} />}
        </Grid>
      </Grid>
    </Dialog>
  );
})

export default VisualizarDEDialog;
